import { currentLang } from 'translations'
import { hasAccessToThis } from './Utilities'

export const getHelpLink = (type: 'helpVideos' | 'helpCenter' | 'punchTerminal' | 'new'): string => {
  const language = currentLang()
  const isAManager = hasAccessToThis('managerPanel')
  const isAnAdmin = hasAccessToThis('adminPanel')
  const isManagerOrAdmin = isAManager || isAnAdmin

  const baseURL = `https://help.merinio.com/${language}`

  const links = {
    en: {
      admin: {
        helpCenter: `${baseURL}/collections/2565016-merinio-for-managers`,
        punchTerminal: `${baseURL}/collections/3444602-punch-terminal-configuration`,
        helpVideos: `${baseURL}/articles/5708166-video-tutorials-for-manager`,
        new: `${baseURL}/collections/2728431-updates-center`
      },
      employee: {
        helpCenter: `${baseURL}/collections/2130168-employee`,
        helpVideos: `${baseURL}/articles/6590833-video-tutorials`,
        new: `${baseURL}/collections/2728431-updates-center`
      }
    },
    fr: {
      admin: {
        helpCenter: `${baseURL}/collections/2565016-merinio-pour-les-gestionnaires`,
        punchTerminal: `${baseURL}/collections/3444602-poincon-et-gestion-du-temps`,
        helpVideos: `${baseURL}/articles/5708166-tutoriels-video-pour-manager`,
        new: `${baseURL}/collections/2728431-centre-des-mises-a-jour`
      },
      employee: {
        helpCenter: `${baseURL}/collections/2130168-merinio-pour-les-employes`,
        helpVideos: `${baseURL}/articles/6590833-tutoriels-videos`,
        new: `${baseURL}/collections/2728431-centre-des-mises-a-jour`
      }
    }
  }
  return links[language][isManagerOrAdmin ? 'admin' : 'employee'][type]
}
